/** @jsxImportSource @emotion/react */
import css from '@emotion/css/macro'
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  ExclamationCircleOutlined,
  HourglassOutlined,
} from '@ant-design/icons'
import type { ICellRendererParams } from 'ag-grid-community'
import type { ReactNode } from 'react'
import colors from '@sportninja/common/constants/appColors'
import type { UserRegistration } from '@sportninja/common/hooks/useUserRegistrationData'
import Text from 'src/components/ts-components/Text'
import {
  REGISTRATION_STATUSES,
  type RegistrationStatusIcon,
} from '../../constants/registrationStatuses'

const STATUS_ICONS: Record<RegistrationStatusIcon, ReactNode> = {
  hourglass: <HourglassOutlined />,
  warning: <ExclamationCircleOutlined />,
  check: <CheckCircleOutlined />,
  close: <CloseCircleOutlined />,
}

/** The registration's status, as a coloured icon and its label. */
const StatusCell = ({
  data: record,
}: ICellRendererParams<UserRegistration>) => {
  const status = REGISTRATION_STATUSES.find(
    ({ id }) => id === record?.status_id
  )
  if (!status) {
    return null
  }

  return (
    <div css={rowStyle}>
      <span
        css={css`
          ${iconStyle}
          color: ${status.color};
        `}
      >
        {STATUS_ICONS[status.icon]}
      </span>
      <Text variant='paragraphSmall' weight='regular' color={colors.WHITE}>
        {status.label}
      </Text>
    </div>
  )
}

export default StatusCell

// ─── Styles ──────────────────────────────────────────────────────

const rowStyle = css`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
`

const iconStyle = css`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  font-size: 16px;
`
